import { createContext, useContext, useState } from "react";

const ToastContext = createContext(undefined);

/**
 * Contexto de notitificaciones
 * @param children
 * @returns {JSX.Element}
 * @constructor
 */
export function ToastProvider({children}){
    const [arrayToast, setArrayToast] = useState([]);

    /**
     * @const cleanToast limpiar los estados del contexto
     */
    const cleanToast = () => {
        setArrayToast([]);
    }

    return(
        <ToastContext.Provider value={{ arrayToast, setArrayToast, cleanToast }}>
            {children}
        </ToastContext.Provider>
    );
}

export const useToast = () => {
    return useContext(ToastContext);
}
